(function () {
  const csPdpStickyAtcSelectors = {
    data: '[data-cs-pdp-sticky-atc-data]',
    select: '[data-cs-pdp-sticky-atc-select]',
    selectValue: '[data-cs-pdp-sticky-atc-select-value]',
    sellingPlan: '[data-cs-pdp-sticky-atc-selling-plan]',
    price: '[data-cs-pdp-sticky-atc-price]',
    submitPrice: '[data-cs-pdp-sticky-atc-submit-price]'
  }

  const csPdpStickyAtcTopBars = '.section-custom-announcement-bar, .announcement-bar, .site-header'

  const csPdpOverlays = ['.yotpo-modal-body', '[data-kl-scroll-locking-modal="true"]'].join(', ')
  const csPdpOverlayOpenClass = 'cs-pdp-overlay-open'

  class CsPdpStickyAtc extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController()
      const signal = this.abortController.signal

      const dataElement = this.querySelector(csPdpStickyAtcSelectors.data)
      this.data = dataElement ? JSON.parse(dataElement.textContent) : { moneyFormat: '${{amount}}' }

      this.select = this.querySelector(csPdpStickyAtcSelectors.select)
      this.selectValueElement = this.querySelector(csPdpStickyAtcSelectors.selectValue)
      this.sellingPlanInput = this.querySelector(csPdpStickyAtcSelectors.sellingPlan)
      this.priceElement = this.querySelector(csPdpStickyAtcSelectors.price)
      this.submitPriceElement = this.querySelector(csPdpStickyAtcSelectors.submitPrice)

      if (this.select) {
        this.select.addEventListener('change', () => this._onSelectChange(), { signal })
        this._onSelectChange()
      }

      this._observeBuybox()
      this._watchOverlays()

      this._updateTopInset()
      const onViewportChange = () => this._requestTopInset()
      window.addEventListener('scroll', onViewportChange, { signal, passive: true })
      window.addEventListener('resize', onViewportChange, { signal, passive: true })
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort()
      if (this.observer) this.observer.disconnect()
      if (this.overlayObserver) this.overlayObserver.disconnect()
      if (this.overlayFrame) cancelAnimationFrame(this.overlayFrame)
      if (this.insetFrame) cancelAnimationFrame(this.insetFrame)
      document.documentElement.classList.remove(csPdpOverlayOpenClass)
    }

    _watchOverlays() {
      if (typeof MutationObserver === 'undefined') return

      this._syncOverlays()
      this.overlayObserver = new MutationObserver(() => this._requestOverlaySync())
      this.overlayObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden']
      })
    }

    _requestOverlaySync() {
      if (this.overlayFrame) return
      this.overlayFrame = requestAnimationFrame(() => {
        this.overlayFrame = null
        this._syncOverlays()
      })
    }

    _syncOverlays() {
      const isOpen = Array.from(document.querySelectorAll(csPdpOverlays)).some(
        (overlay) => overlay.getClientRects().length > 0
      )
      document.documentElement.classList.toggle(csPdpOverlayOpenClass, isOpen)
    }

    _requestTopInset() {
      if (this.insetFrame) return
      this.insetFrame = requestAnimationFrame(() => {
        this.insetFrame = null
        this._updateTopInset()
      })
    }

    _updateTopInset() {
      let inset = 0

      document.querySelectorAll(csPdpStickyAtcTopBars).forEach((bar) => {
        const position = window.getComputedStyle(bar).position
        if (position !== 'fixed' && position !== 'sticky') return

        const rect = bar.getBoundingClientRect()
        if (rect.bottom <= 0) return

        inset = Math.max(inset, rect.bottom)
      })

      this.style.setProperty('--cs-pdp-sticky-atc-top', Math.round(inset) + 'px')
    }

    _onSelectChange() {
      const option = this.select.options[this.select.selectedIndex]
      if (!option) return

      if (this.sellingPlanInput) this.sellingPlanInput.value = option.dataset.sellingPlanId || ''
      if (this.selectValueElement) this.selectValueElement.textContent = option.textContent.trim()

      const price = parseInt(option.dataset.unitPrice, 10)
      if (Number.isNaN(price)) return

      const parsedMultiplier = parseInt(option.dataset.purchaseMultiplier, 10)
      const purchaseMultiplier = Number.isNaN(parsedMultiplier) ? 1 : parsedMultiplier

      const formatted = window.csPdpFormatMoney(price * purchaseMultiplier, this.data.moneyFormat)
      if (this.priceElement) this.priceElement.textContent = formatted
      if (this.submitPriceElement) this.submitPriceElement.textContent = formatted
    }

    _observeBuybox() {
      const target = document.querySelector('[data-cs-pdp-buybox-actions]')
      if (!target || typeof IntersectionObserver === 'undefined') return

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0
            this.classList.toggle('is-visible', scrolledPast)
          })
        },
        { threshold: 0 }
      )

      this.observer.observe(target)
    }
  }

  if (!customElements.get('cs-pdp-sticky-atc')) {
    customElements.define('cs-pdp-sticky-atc', CsPdpStickyAtc)
  }
})()
